/*
  Beyours — Quick View behaviours (redesigned quick-buy drawer/popover).
  ==========================================================================
  Loaded globally on collection pages (via snippets/product-item.liquid). The
  quick-view markup lives in sections/main-product.liquid and is injected into
  <quick-buy-drawer>/<quick-buy-popover> via innerHTML, so INLINE scripts in
  that fragment never run. Everything dynamic is handled here from the document
  level instead:

    1. variant:changed  → live in-button price + price row + % badge
       (Prestige's <product-payment-container> already sets disabled/sold-out
        and the label from data-button-content; we only inject the price.)
    2. gallery dots      → active dot follows horizontal scroll
    3. size chart        → lazy-load /pages/{handle}, inch/cm toggle rebind

  variant:changed bubbles (theme.js triggerEvent → bubbles:true), so a single
  document listener covers every injected quick view.
  ==========================================================================
*/
(function () {
  if (window.__beyoursQuickView) return;
  window.__beyoursQuickView = true;

  /* ---- INR money, matching Liquid's money_without_trailing_zeros (e.g. "Rs. 3,590") ---- */
  function money(cents) {
    var n = Math.round((Number(cents) || 0) / 100);
    return 'Rs. ' + n.toLocaleString('en-IN');
  }
  function pctOff(price, compare) {
    if (!compare || compare <= price) return 0;
    return Math.round((compare - price) * 100 / compare);
  }

  /* ================= 1 · live price on variant change ================= */
  document.addEventListener('variant:changed', function (event) {
    var form = event.target;
    if (!form || !form.closest) return;
    var qv = form.closest('[data-qv]');
    if (!qv) return;
    var v = event.detail && event.detail.variant;
    if (!v) return;

    var priceEl = qv.querySelector('[data-qv-price]');
    var compareEl = qv.querySelector('[data-qv-compare]');
    var badgeEl = qv.querySelector('[data-qv-badge]');
    var hasCompare = v.compare_at_price && v.compare_at_price > v.price;

    if (priceEl) priceEl.textContent = money(v.price);
    if (compareEl) {
      if (hasCompare) { compareEl.textContent = money(v.compare_at_price); compareEl.hidden = false; }
      else compareEl.hidden = true;
    }
    if (badgeEl) {
      if (hasCompare) { badgeEl.textContent = pctOff(v.price, v.compare_at_price) + '% OFF'; badgeEl.hidden = false; }
      else badgeEl.hidden = true;
    }

    /* In-button price. <product-payment-container> runs first (it's bound on the
       form) and set the label from the OLD data-button-content, so refresh the
       attribute AND the visible label here. Leave the sold-out label alone. */
    var btn = qv.querySelector('[data-product-add-to-cart-button]');
    if (btn) {
      var label = 'Add to bag — ' + money(v.price);
      btn.setAttribute('data-button-content', label);
      if (v.available) {
        var textEl = btn.querySelector('.loader-button__text') || btn;
        textEl.textContent = label;
      }
    }
  });

  /* ================= 2 · gallery dots (scroll doesn't bubble → capture) ================= */
  document.addEventListener('scroll', function (event) {
    var track = event.target;
    if (!track || !track.getAttribute || track.getAttribute('data-qv-gallery-track') === null) return;
    var gallery = track.closest('[data-qv-gallery]');
    if (!gallery) return;
    var dots = gallery.querySelectorAll('[data-qv-gallery-dots] .qv-dot');
    if (!dots.length || !track.clientWidth) return;
    /* one dot per slide — measure a real slide (incl. gap) since slides are now
       narrower than the track (filmstrip), not full-width */
    var slides = track.querySelectorAll('.qv-gallery__slide');
    var unit = slides.length > 1 ? (slides[1].offsetLeft - slides[0].offsetLeft)
      : (slides[0] ? slides[0].offsetWidth : track.clientWidth);
    if (!unit) return;
    var i = Math.round(track.scrollLeft / unit);
    if (i < 0) i = 0; if (i > dots.length - 1) i = dots.length - 1;
    for (var x = 0; x < dots.length; x++) dots[x].classList.toggle('is-on', x === i);
  }, true);

  /* ============ 2b · click a gallery photo → zoom lightbox ============ */
  document.addEventListener('click', function (event) {
    var img = event.target && event.target.closest ? event.target.closest('.qv-gallery__slide img') : null;
    if (!img) return;
    var src = img.currentSrc || img.src || '';
    src = /([?&])width=\d+/.test(src) ? src.replace(/([?&])width=\d+/, '$1width=1600')
      : src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=1600';
    var ov = document.createElement('div');
    ov.className = 'qv-zoom';
    ov.innerHTML = '<img alt="" src="' + src + '"><button type="button" class="qv-zoom__close" aria-label="Close">✕</button>';
    document.body.appendChild(ov);
    requestAnimationFrame(function () { ov.classList.add('is-on'); });
    function onKey(e) { if (e.key === 'Escape') close(); }
    function close() {
      ov.classList.remove('is-on');
      document.removeEventListener('keydown', onKey);
      setTimeout(function () { if (ov.parentNode) ov.parentNode.removeChild(ov); }, 200);
    }
    ov.addEventListener('click', close);
    document.addEventListener('keydown', onKey);
  });

  /* ================= 3 · size chart lazy-load + inch/cm rebind ================= */
  var chartCache = {};

  function bindInchCm(wrapper) {
    if (!wrapper || wrapper.dataset.qvBound === '1') return;
    wrapper.dataset.qvBound = '1';
    /* Mirrors the inch/cm toggle in sections/san-bulk-purchase.liquid */
    wrapper.addEventListener('click', function (e) {
      if (e.target.tagName !== 'I') return;
      var icon = e.target;
      var carousel = wrapper.querySelector('.table-carousel');
      var firstTable = wrapper.querySelector('.table-wrapper');
      if (firstTable && carousel) {
        carousel.scrollLeft += icon.classList.contains('size-inch') ? -firstTable.clientWidth : firstTable.clientWidth;
      }
      wrapper.querySelectorAll('i').forEach(function (i) { i.classList.remove('active-btn'); });
      icon.classList.add('active-btn');
    });
  }

  function fillPanel(panel, html) {
    panel.innerHTML = html;
    panel.dataset.loaded = '1';
    /* If the fetched content is a native <size-chart>, theme.js upgrades it and
       manages inch/cm itself. Otherwise bind the toggle on the .size-wrapper. */
    if (!panel.querySelector('size-chart')) {
      bindInchCm(panel.querySelector('.size-wrapper'));
    }
  }

  function loadSizeChart(panel) {
    if (!panel || panel.dataset.loaded === '1' || panel.dataset.loading === '1') return;
    var handle = panel.getAttribute('data-handle');
    if (!handle) { fillPanel(panel, '<p style="color:#888780">Size chart not available.</p>'); return; }
    if (chartCache[handle]) { fillPanel(panel, chartCache[handle]); return; }

    panel.dataset.loading = '1';
    fetch('/pages/' + encodeURIComponent(handle))
      .then(function (r) { if (!r.ok) throw new Error('not found'); return r.text(); })
      .then(function (text) {
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var content = doc.querySelector('size-chart')
          || doc.querySelector('.size-wrapper')
          || doc.querySelector('.page__content')
          || doc.querySelector('.rte')
          || doc.querySelector('main .shopify-section')
          || doc.querySelector('article');
        var html = content ? content.outerHTML : '<p style="color:#888780">Size chart content not found.</p>';
        chartCache[handle] = html;
        panel.dataset.loading = '';
        fillPanel(panel, html);
      })
      ['catch'](function () {
        panel.dataset.loading = '';
        panel.dataset.loaded = '1';
        panel.innerHTML = '<p style="color:#888780">Unable to load size chart.</p>';
      });
  }

  /* Open trigger is a native is="toggle-button" (theme opens the drawer/popover);
     we relocate the shell to <body> (so its fixed overlay escapes the quick-buy
     drawer's transform) and lazy-load its panel. Capture phase so the relocation
     happens before the theme's toggle-button opens it. */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[aria-controls]');
    if (!trigger) return;
    var id = trigger.getAttribute('aria-controls') || '';
    if (id.indexOf('qv-sizechart-') !== 0) return;
    var target = document.getElementById(id);
    if (!target) return;
    if (target.parentElement !== document.body) {
      /* drop any stale twin left in <body> from a previous open of this product */
      var twins = document.querySelectorAll('[id="' + id + '"]');
      for (var t = 0; t < twins.length; t++) {
        if (twins[t] !== target && twins[t].parentElement === document.body) twins[t].remove();
      }
      document.body.appendChild(target);
    }
    var panel = target.querySelector('[data-qv-size-panel]');
    if (panel) loadSizeChart(panel);
  }, true);
})();
